import * as React from "react";
import {
  Select as ShadcnSelect,
  SelectContent as ShadcnSelectContent,
  SelectGroup as ShadcnSelectGroup,
  SelectItem as ShadcnSelectItem,
  SelectLabel as ShadcnSelectLabel,
  SelectScrollDownButton as ShadcnSelectScrollDownButton,
  SelectScrollUpButton as ShadcnSelectScrollUpButton,
  SelectSeparator as ShadcnSelectSeparator,
  SelectTrigger as ShadcnSelectTrigger,
  SelectValue as ShadcnSelectValue,
} from "@/components/shadcn/select";

/**
 * Extended Select component for custom UI usage.
 * Accepts all native select props and custom children.
 */
export const Select = ShadcnSelect;
export const SelectGroup = ShadcnSelectGroup;
export const SelectItem = ShadcnSelectItem;
export const SelectLabel = ShadcnSelectLabel;
export const SelectScrollDownButton = ShadcnSelectScrollDownButton;
export const SelectScrollUpButton = ShadcnSelectScrollUpButton;
export const SelectSeparator = ShadcnSelectSeparator;

// Override SelectTrigger to always have bg-white
export const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof ShadcnSelectTrigger>,
  React.ComponentPropsWithoutRef<typeof ShadcnSelectTrigger>
>(function SelectTriggerWithBgWhite(props, ref) {
  return <ShadcnSelectTrigger {...props} ref={ref} className={["bg-white", props.className].filter(Boolean).join(" ")} />;
});

// Override SelectContent to always have bg-white
export const SelectContent = React.forwardRef<
  React.ElementRef<typeof ShadcnSelectContent>,
  React.ComponentPropsWithoutRef<typeof ShadcnSelectContent>
>(function SelectContentWithBgWhite(props, ref) {
  return <ShadcnSelectContent {...props} ref={ref} className={["bg-white", props.className].filter(Boolean).join(" ")} />;
});

export const SelectValue = ShadcnSelectValue;

